import "select2";
import "select2/dist/js/i18n/sv.js";
import calculateCO from "./calculateCO.js";

export default function selectAirports() {
  calculateCO();

  $.fn.select2.amd.define(
    "SearchableSingleSelection",
    [
      "select2/utils",
      "select2/selection/single",
      "select2/selection/eventRelay",
      "select2/dropdown/search",
    ],
    function (Utils, SingleSelection, EventRelay, DropdownSearch) {
      var adapter = Utils.Decorate(SingleSelection, DropdownSearch);
      adapter = Utils.Decorate(adapter, EventRelay);

      adapter.prototype.render = function () {
        var $rendered = DropdownSearch.prototype.render.call(
          this,
          SingleSelection.prototype.render
        );

        this.$searchContainer.hide();
        this.$element
          .siblings(".select2")
          .find(".selection")
          .prepend(this.$searchContainer);

        return $rendered;
      };

      var bindOrigin = adapter.prototype.bind;
      adapter.prototype.bind = function (container) {
        var self = this;

        bindOrigin.apply(this, arguments);

        container.on("open", function () {
          self.$selection.hide();
          self.$searchContainer.show();
          if (self.$search.length) {
            self.$search[0].focus();
          }
        });

        container.on("close", function () {
          self.$searchContainer.hide();
          self.$selection.show();
        });
      };

      return adapter;
    }
  );

  /*
   * A select2 adapter to show simple dropdown list without a searchbox inside
   */
  $.fn.select2.amd.define(
    "UnsearchableDropdown",
    [
      "select2/utils",
      "select2/dropdown",
      "select2/dropdown/attachBody",
      "select2/dropdown/closeOnSelect",
    ],
    function (Utils, Dropdown, AttachBody, CloseOnSelect) {
      var adapter = Utils.Decorate(Dropdown, AttachBody);
      adapter = Utils.Decorate(adapter, CloseOnSelect);
      return adapter;
    }
  );

  $(".select2").select2({
    selectionAdapter: $.fn.select2.amd.require("SearchableSingleSelection"),
    dropdownAdapter: $.fn.select2.amd.require("UnsearchableDropdown"),
    ajax: {
      url: function (params) {
        return (
          "https://sitaopen.api.aero/data/v3/airports/match/" + params.term
        );
      },
      dataType: "json",
      headers: {
        "X-apiKey": "7a9d8c773465a0121836e1d3cced4b6c",
      },
      delay: 250,
      processResults: function (data) {
        const airports = data.airports;
        let formatted = [];
        if (airports) {
          for (var i = 0; i < airports.length; i++) {
            let formattedObject = {
              id: airports[i].iataCode,
              text:
                airports[i].city +
                " - " +
                airports[i].name +
                " - " +
                airports[i].iataCode,
            };
            formatted.push(formattedObject);
          }
        }
        return {
          results: formatted,
        };
      },
    },
    theme: "default",
    placeholder: "Sök på stad, flygplats eller kod",
    language: "sv",
  });

  $(".select2--from").on("select2:select", function (e) {
    $(".select2--to").select2("open");
  });
}
